export const AGENCY_TALENT_PERMISSIONS: IAgencyTalentPermissions = {
  videos: {
    label: 'videos',
    key: 'Videos',
  },
  primary_image: {
    label: 'primary image',
    key: 'Primary Image Selection',
  },
  images: {
    label: 'images',
    key: 'Images',
  },
  audio_files: {
    label: 'audio files',
    key: 'Audio Files',
  },
  resume_categories: {
    label: 'resume categories',
    key: 'Resume Categories',
  },
  composite_card: {
    label: 'Composite Card',
    key: 'Composite Card',
  },
  documents: {
    label: 'Documents',
    key: 'Documents',
  },
};

export interface IAgencyTalentPermissionsValue {
  label: string;
  key: string;
}

export interface IAgencyTalentPermissions {
  videos: IAgencyTalentPermissionsValue;
  primary_image: IAgencyTalentPermissionsValue;
  images: IAgencyTalentPermissionsValue;
  audio_files: IAgencyTalentPermissionsValue;
  resume_categories: IAgencyTalentPermissionsValue;
  composite_card: IAgencyTalentPermissionsValue;
  documents: IAgencyTalentPermissionsValue;
}
